import { render, staticRenderFns } from "./modal-house.vue?vue&type=template&id=cb489d86&scoped=true"
import script from "./modal-house.vue?vue&type=script&lang=js"
export * from "./modal-house.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb489d86",
  null
  
)

export default component.exports